import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b89fbaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"500px","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_2 = { class: "contnet-warp" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-item-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top" }),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }),
  /*#__PURE__*/_createElementVNode("div", { class: "bottom" })
], -1))
const _hoisted_4 = { class: "content-warp-item-right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-item-right-bg" }, null, -1))
const _hoisted_6 = { class: "content-warp-item-right-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-item-right-text-line" }, null, -1))
const _hoisted_8 = { class: "content-warp-item-right-text-inner" }
const _hoisted_9 = { class: "content-name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, onMounted } from 'vue';
import { selfAdaption, useDataAssembly } from './hooks';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-2-4',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});

let data = useDataAssembly(props.tableHeaderList, props.tableDataList);
let zindex = 6;
data.value.tipData.forEach(item => {
  item.push(zindex--);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "patient-sex",
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "contnet",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tipData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "contnet-warp-item",
              key: index,
              style: _normalizeStyle({
              '--color': `var(--theme-color-${index + 1},#000)`,
              '--zindex': `${item[item.length - 1]}`,
              '--left': `${(index + 1) % 2 == 0 ? '-302px' : '184px'}`,
              '--lineLeft': `${(index + 1) % 2 == 0 ? '188px' : '-94px'}`,
              '--afterRight': `${(index + 1) % 2 == 0 ? '84px' : '-5px'}`
            })
            }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.slice(0, item.length - 1), (item2, index2) => {
                        return (_openBlock(), _createElementBlock("div", { key: index2 }, _toDisplayString(item2.label) + "：" + _toDisplayString(item2.value), 1))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ], 4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` }),
              key: index
            }, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(item.value), 1)
            ], 4))
          }), 128))
        ])
      ])
    ], 512)
  ], 4))
}
}

})